import React from "react"

import style from "./RoundedCheckBox.module"

export default function RoundedCheckBox({ checked, onChange, readOnly }) {
  return (
    <div>
      <input
        className={style.input}
        type="checkbox"
        checked={checked}
        onChange={onChange}
        readOnly={readOnly}
      />

      <div
        className={`${style.check} ${checked && style.checked}`}
        onClick={onChange}
      />
    </div>
  )
}
